<template>
  <v-app>
    <v-app-bar :flat=true app dark>
      <v-toolbar-title class="headline text-uppercase">
        <span>ParcoursVis</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text  >
        <span class="loader" v-show="total != expected_total"></span>
        <span class="mr-2" :style="expected_total == total ? {} : {backgroundColor: '#ffc107', color: 'black'}">Number of Patients: {{total.toLocaleString()}} processed / {{expected_total.toLocaleString()}} total ({{filtered_total.toLocaleString()}} filtered out)</span>
        <!--<span class="mr-2">Number of Patients: {{patients_num}}(processed)/ {{progress_num}}(total)</span>-->
      </v-btn>
      <v-btn
        text
        href="https://www.docs.google.com/document/d/1CdtztQZotajToOB1xUjEQaGacJnx8iegxo4zuvfAbtw/edit?usp=sharing"
        target="_blank"
      >
        <span class="mr-2">DATA INFO</span>
      </v-btn>
      <v-btn
        text
        href="https://www.aviz.fr/ParcoursVis/UserManual"
        target="_blank"
      >
        <span class="mr-2">HELP</span>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-row :style="{display: (comparison_mode == ComparisonMode.NONE_COMPARISON_MODE ? 'none' : 'block'), marginTop: '12px', marginLeft: '12px', marginRight: '12px'}">
        <v-btn :disabled="comparison_mode == ComparisonMode.SOURCE_COMPARISON_MODE" @click="set_comparison_mode(ComparisonMode.SOURCE_COMPARISON_MODE)">
          <v-icon>{{icons.mdiArrowLeftThick}}</v-icon>
          Previous
        </v-btn>
        <v-btn :disabled="comparison_mode == ComparisonMode.TARGET_COMPARISON_MODE" @click="set_comparison_mode(ComparisonMode.TARGET_COMPARISON_MODE)">
          Next
          <v-icon>{{icons.mdiArrowRightThick}}</v-icon>
        </v-btn>
        <v-btn @click='set_comparison_mode(ComparisonMode.NONE_COMPARISON_MODE)' style="float: right;">Stop Comparison</v-btn>
      </v-row>
      <v-row style="position: relative">
        <v-col cols=9>
          <div id="mainview">
            <main-view :style="{display: view_type == ViewType.MAIN_VIEW_TYPE ? 'block' : 'none'}"/>
            <sequence-view :style="{display: view_type == ViewType.SEQUENCE_VIEW_TYPE ? 'block' : 'none'}"/>
          </div>
        </v-col>
        <v-col cols=3>
          <side-view :style="{'padding-left':'0px', 'padding-right':'0px'}" id="sideview"/>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import MainView     from './components/MainView'
import SideView     from './components/SideView'
import SequenceView from './components/SequenceView'
import { ViewType, ComparisonMode }  from './Config'
import { mapState, mapGetters, mapActions } from 'vuex'
import { mdiArrowLeftThick, mdiArrowRightThick } from '@/svgIcons'

export default {
  name: 'App',
  components: {
    MainView,
    SequenceView,
    SideView
  },
  data: () => ({
    ViewType: ViewType,
    ComparisonMode: ComparisonMode,
    icons: { mdiArrowLeftThick, mdiArrowRightThick}
  }),
  mounted() {
    this.initApp()
    document.addEventListener('keyup', this.keyupHandler);
  },
  destroyed() {
    document.removeEventListener('keyup', this.keyupHandler);
  },
  computed: {
    ...mapState({
      view_type: state => state.view_type,
    }),
    ...mapGetters(['total', 'expected_total', 'filtered_total', 'history', 'comparison_mode']),
  },
  methods: {
    ...mapActions(['initApp', 'set_comparison_mode']),

    /** \brief  Handle Ctrl+Z and Ctrl+Y
     * \param event the keyup event we captured */
    keyupHandler (event) {
      if (event.ctrlKey && event.key === 'z')
        this.history.undo();
      else if (event.ctrlKey && event.key === 'y')
        this.history.redo();
    },
  }
};
</script>
<style>
body {
  padding: 0;  
}
.loader {
  border: 3px solid #f3f3f3; /* Light grey */
  border-top: 3px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
